export default function(RegulatorClass) {
  'ngInject';
  return reg_id => {
    return RegulatorClass.basicName(reg_id);
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/RegulatorBasicName.js